import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  ShowButton,
  SelectField,
  ChipField,
  Filter,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeHotline } from "../../constant/TypeHotline";
import Actions from '../Actions'

const HotlineFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="name_contains" />
      <TextInput source="tel_contains" />
      <SelectInput source="type" choices={typeHotline} />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        label="Project"
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const HotlineList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="hotline.hotline"
      bulkActions={false}
      filters={<HotlineFilter />}
      filterDefaultValues={filter}
      actions={<Actions create />}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <TextField source="tel" />
        <SelectField
          source="type"
          optionText={<ChipField source="name" />}
          choices={typeHotline}
        />
        <ReferenceField linkType={false} source="project" reference="project">
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/hotline/HotlineList.js